<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
    name: "TariffSettingFilter",
    model: {
        prop: 'searchParams',
        event: 'change',
    },
    props: {
        searchParams: {
            type: Object,
            default() {
                return {
                    companyIds: [],
                    productIds: [],
                }
            }
        },
        companies: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    computed: {
      productTypes() {
          return this.$store.getters.ALL_ORDER_TYPES;
      },
    },
    watch: {
        // selectedCompanyIds(val) {
        //     // if (val.length) {
        //   this.searchParams.companyIds = this.localCompanies.filter(item => this.selectedCompanyIds.includes(item.companyName)).map(c => c.ids).flat()
        //       // this.searchParams.companyIds = val.flat();
        //     // }
        // }
    },
    data() {
        return {
            localCompanies: [],
            selectedCompanyIds: [],
        }
    },
    methods: {
      setSearchParams(event) {
        this.searchParams.companyIds = this.localCompanies.filter(item => event.includes(item.companyName)).map(c => c.ids).flat()
      }
    },
    mounted() {
        this.localCompanies = Object.values(
            this.companies.reduce((acc, item) => {
                const key = item.companyName.trim()
                if (!acc[key]) {
                    acc[key] = {
                        companyName: key,
                        ids: []
                    }
                }
                acc[key].ids.push(item.id)
                return acc
            }, {})
        )
    }
})
</script>

<template>
<div class="tariff-setting-filter">
    <div class="row">
        <div class="col-6">
            <label>Тип продукту</label>
            <el-select v-model="searchParams.productIds" class="w-100" clearable multiple>
                <el-option v-for="item in productTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div class="col-6">
            <label>Страхова компанія</label>
            <el-select v-model="selectedCompanyIds" class="w-100" clearable multiple @change="setSearchParams">
                <el-option v-for="item in localCompanies"
                           :key="item.companyName"
                           :label="item.companyName"
                           :value="item.companyName">
                </el-option>
            </el-select>
        </div>
    </div>
</div>
</template>

<style scoped lang="scss">
.tariff-setting-filter {
    .filter-button {
        position: absolute;
        right: 0;
        display: flex;
        cursor: pointer;

        font-family: 'Geist',serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: #09090B;
        gap: 2px;
    }
}
</style>
